export default __webpack_public_path__ + "static/media/harmony.08c04056.svg";